import React from 'react'

const StatsCard = (props) => {
    return (
        <>
            <div style={{ display: 'inline-flex', flexDirection: 'column', justifyContent: 'space-between', alignItem: 'center', marginRight: '2vw' }}>
                <img src={props.imgUrl} alt="logo" />
                <div style={{ display: 'inline-block' }}>
                    <p>{props.cardLabel}</p>
                    <p style={{ marginTop: '4px' }}>{props.cardBody}</p>
                </div>
            </div>
        </>
    )
}

export default StatsCard